'use strict';

import $ from 'jquery';

export default function featureDetails(scope) {
    $(scope.feature).each(function () {
        const feature = $(this);
        const toggle = feature.find(scope.toggle).first();
        const close = feature.find(scope.close).first();
        const details = feature.find(scope.details);

        details.find(scope.toggle).on('click', function () {
            details.slideToggle(scope.speed);
        });

        feature.find('.js-price-feature-expand').on('click', function () {
            $(this).toggleClass('is-open');

            feature.find('> .price__feature-expandable').slideToggle();
            return false;
        });

        toggle.on('click', function (e) {
            // Ignore closing/opening the slide if the user clicked on a link
            if ($(e.target).is('a') && !$(e.target).hasClass('js-price-feature-toggle')) {
                return true;
            }

            feature.toggleClass('active');
            details.slideToggle(scope.speed);

            toggle.each(function () {
                const altText = $(this).data('altText');
                if (altText) {
                    const text = $(this).text();
                    $(this).text(altText);
                    $(this).data('altText', text);
                }
            });

            return false;
        });

        close.on('click', function (e) {
            e.stopPropagation();
            feature.removeClass('active');
            details.slideToggle(scope.speed);
        });
    });
}
